import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, PlusSquareFilled, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Form, FormInstance, Select, Input, Space } from 'antd';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { IFormacaoPessoaFisica } from "./InterfacePessoaFisica";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { IAreaConhecimento } from "../../../Interfaces/Interfaces";
import { lista_tipo_formacao } from "../../../config/Contantes";

interface IProps {
  form: FormInstance<any>;
  formacoes: IFormacaoPessoaFisica[];
  setFormacoes: React.Dispatch<React.SetStateAction<IFormacaoPessoaFisica[]>>;
  areas: IAreaConhecimento[];
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
}

const { Option } = Select;
const PessoaFisicaFormacao = ({ form, formacoes, setFormacoes, areas, manter }: IProps) => {
  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo edição
  const [exibirModalPfFormacao, setExibirModalPfFormacao] = useState(false);
  const [exibirFormacaoCadastrada, setExibirFormacaoCadastrada] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");


  useEffect(() => {
    if (formacoes && formacoes.length === 0) {
      setExibirFormacaoCadastrada("none")
    } else {
      setExibirFormacaoCadastrada("inline")
      setValoresAuxiliares();
    }
  }, [formacoes]);

  const setValoresAuxiliares = (() => {
    formacoes.forEach(formacao => {
      lista_tipo_formacao.forEach(e => {
        if (formacao.csTpFormacao === e.enum) {
          formacao.tipoFormacao = e.tipoFormacao
        }
      })
    })
  })


  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // PASSA O MODAL PARA O MODO EDIÇÃO
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // PASSA O MODAL PARA ABRIR E EXIBIR DETALHES
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo telefone", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalPfFormacao(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalPfFormacao(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalPfFormacao(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarFormacao = () => {
    if (Number(form.getFieldValue("nuAnoConclusao")) < 1950 || Number(form.getFieldValue("nuAnoConclusao")) > new Date().getFullYear()) {
      errorMessage("Informe um ano de conclusão válido");
    } else if (Number(form.getFieldValue("nuCargaHoraria")) < 1) {
      errorMessage("Informe uma carga horária válida");
    }
    else {
      form
        .validateFields([
          "idPessoaFisicaFormacao",
          "idAreaConhecimento",
          "nomeAreaConhecimento",
          "csTpFormacao",
          "tipoFormacao",
          "teInstituicao",
          "teCurso",
          "nuCargaHoraria",
          "nuAnoConclusao",
          "ativo",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosFormacao();
          // successMessage("Formacao Adicionada");
          // successMessage(estadoModal === 3 ? "Formacao Alterada" : "Formacao Adicionada");

        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido");
        });
    }
  };

  function setDadosFormacao() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setFormacoes(pre => {
        return pre.map(formac => {
          if (formac.emEdicao) {
            return ({
              idPessoaFisicaFormacao: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaFormacao")) : -1,
              csTpFormacao: Number(form?.getFieldValue("csTpFormacao")),
              tipoFormacao: form?.getFieldValue("tipoFormacao"),
              teInstituicao: form?.getFieldValue("teInstituicao").toUpperCase(),
              teCurso: form?.getFieldValue("teCurso").toUpperCase(),
              nuCargaHoraria: Number(form?.getFieldValue("nuCargaHoraria")),
              nuAnoConclusao: Number(form?.getFieldValue("nuAnoConclusao")),
              idAreaConhecimento: Number(form?.getFieldValue("idAreaConhecimento")),
              nomeAreaConhecimento: form?.getFieldValue("nomeAreaConhecimento"),
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return formac
          }
        })
      });
    } else {
      setFormacoes([
        ...formacoes,
        {
          idPessoaFisicaFormacao: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaFormacao")) : -1,
          csTpFormacao: Number(form?.getFieldValue("csTpFormacao")),
          tipoFormacao: form?.getFieldValue("tipoFormacao"),
          teInstituicao: form?.getFieldValue("teInstituicao").toUpperCase(),
          teCurso: form?.getFieldValue("teCurso").toUpperCase(),
          nuCargaHoraria: Number(form?.getFieldValue("nuCargaHoraria")),
          nuAnoConclusao: Number(form?.getFieldValue("nuAnoConclusao")),
          idAreaConhecimento: Number(form?.getFieldValue("idAreaConhecimento")),
          nomeAreaConhecimento: form?.getFieldValue("nomeAreaConhecimento"),
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }
    form.resetFields([
      "idPessoaFisicaFormacao",
      "idAreaConhecimento",
      "nomeAreaConhecimento",
      "csTpFormacao",
      "tipoFormacao",
      "teInstituicao",
      "teCurso",
      "nuCargaHoraria",
      "nuAnoConclusao",
      "ativo",
    ]);
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const handlerTpFormacao = async (value: any) => {
    form.setFieldsValue({
      tipoFormacao: value.children,
      csTpFormacao: value.key,
    });
  };

  const handlerArea = async (value: any) => {
    form.setFieldsValue({
      nomeAreaConhecimento: value.children,
      idAreaConhecimento: value.key,
    });
  };

  const maskCargaHoraria = async (isValue: any) => {
    isValue = isValue + "";
    isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
    form.setFieldsValue({
      nuCargaHoraria: isValue,
    });
  };

  const maskAnoConclusao = async (isValue: any) => {
    isValue = isValue + "";
    isValue = isValue.replace(/\D/g, ""); //Remove tudo o que não é dígito
    form.setFieldsValue({
      nuAnoConclusao: isValue,
    });
  };

  const setFieldsDetalharEditar = (IFormacao: IFormacaoPessoaFisica) => {
    form.setFieldsValue({
      "idPessoaFisicaFormacao": IFormacao.idPessoaFisicaFormacao,
      "csTpFormacao": IFormacao.csTpFormacao,
      "tipoFormacao": IFormacao.tipoFormacao,
      "teInstituicao": IFormacao.teInstituicao,
      "teCurso": IFormacao.teCurso,
      "nuCargaHoraria": IFormacao.nuCargaHoraria,
      "nuAnoConclusao": IFormacao.nuAnoConclusao,
      "idAreaConhecimento": IFormacao.idAreaConhecimento,
      "nomeAreaConhecimento": IFormacao.nomeAreaConhecimento,
    });
  }


  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Tipo",
      dataIndex: "",
      render: (IFormacao: IFormacaoPessoaFisica) => <>{IFormacao.tipoFormacao}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Curso",
      dataIndex: "",
      render: (IFormacao: IFormacaoPessoaFisica) => <>{IFormacao.teCurso}</>,
    },
    {
      // width: 200,
      key: "3",
      title: "Ano de Formação",
      dataIndex: "",
      render: (IFormacao: IFormacaoPessoaFisica) => <>{IFormacao.nuAnoConclusao}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IFormacao: IFormacaoPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2  || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(IFormacao);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  setFieldsDetalharEditar(IFormacao);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  formacoes.forEach(formacao => {
                    if (formacao === IFormacao) {
                      formacao.statusReg = 1;
                      formacao.touched = true;
                      formacao.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      formacao.emEdicao = false;
                    }
                  })
                  IFormacao.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (IFormacao?.idPessoaFisicaFormacao && IFormacao?.idPessoaFisicaFormacao < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setFormacoes(formacoes.filter((formacao) => formacao !== IFormacao));
                }}
              />
            </div>

            <div style={{ display: (IFormacao?.idPessoaFisicaFormacao && IFormacao?.idPessoaFisicaFormacao > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
              <>
                <PlusSquareFilled
                  title="Desmarcar para exclução/inativação"
                  style={{ color: "blue", display: (IFormacao?.statusReg === 1 || IFormacao?.statusReg === undefined) ? "none" : "inline" }}
                  onClick={() => {
                    IFormacao.touched = true; // MARCA O REGISTRO ALTERADO.
                    IFormacao.statusReg = (IFormacao.statusReg === 1 ? 2 : 1);
                    setFormacoes(pre => { //TROCA O REGISTRO DO DATASET PELO REGISTRO EM ALTERAÇÃO
                      return pre.map(formacao => {
                        if (formacao.idPessoaFisicaFormacao === IFormacao.idPessoaFisicaFormacao) {
                          return IFormacao;
                        } else {
                          return formacao;
                        }
                      });
                    });
                  }}
                />
                <DeleteOutlined
                  title="Marcar para exclução/inativação"
                  style={{ color: "red", display: (IFormacao?.statusReg === 1 || IFormacao?.statusReg === undefined) ? "inline" : "none" }}
                  onClick={() => {
                    IFormacao.touched = true; // MARCA O REGISTRO ALTERADO.
                    IFormacao.statusReg = (IFormacao.statusReg === 1 ? 2 : 1);
                    setFormacoes(pre => {
                      return pre.map(formacao => {
                        if (formacao.idPessoaFisicaFormacao === IFormacao.idPessoaFisicaFormacao) {
                          return IFormacao;
                        } else {
                          return formacao;
                        }
                      });
                    });
                  }}
                />
              </>
            </div>
          </Space>
      ),
    },

  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
    controleDaGrid("cancelar");
    form.resetFields([
      "idPessoaFisicaFormacao",
      "idAreaConhecimento",
      "nomeAreaConhecimento",
      "csTpFormacao",
      "tipoFormacao",
      "teInstituicao",
      "teCurso",
      "nuCargaHoraria",
      "nuAnoConclusao",
      "ativo",
    ]);
  }


  return (
    // <Card title='Formações/Capacitações' variant="borderless" style={{ width: "100%" }}>
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirFormacao"
        type="primary"
        shape="round"
        onClick={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirFormacao");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Formação
      </Button>

      <>
        <Modal title="Formação/Capacitação" open={exibirModalPfFormacao}
          style={{ top: 20 }}
          destroyOnHidden={true}
          //        width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarFormacao}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Row>
            <Col xs={12} xl={12}>
              <Form.Item label="Tipo de Formação"
                labelCol={{ span: 24 }}
                name="tipoFormacao"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "O Tipo de formação é obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Tipo'
                  onChange={(_, index) => {
                    handlerTpFormacao(index);
                  }}
                  disabled={estadoModal === 2}
                >
                  {lista_tipo_formacao?.map((e: any) => (
                    <Option key={e.enum} value={e.enum}>
                      {e.tipoFormacao}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={12} xl={12}>
              <Form.Item label="Área"
                labelCol={{ span: 24 }}
                name="nomeAreaConhecimento"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "A área de conhecimento é obrigatória",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Área'
                  onChange={(_, index) => {
                    handlerArea(index);
                  }}
                  disabled={estadoModal === 2}
                >
                  {areas?.map((e: IAreaConhecimento) => (
                    <Option key={e.idAreaConhecimento} value={e.idAreaConhecimento}>
                      {e.nmArea}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24}>
              <Form.Item label='Instituição'
                labelCol={{ span: 24 }}
                name='teInstituicao'
                rules={[
                  {
                    required: true,
                    message: 'O campo Instituição é obrigatório.',
                  },
                ]}
              >
                <Input
                  placeholder='Instituição'
                  maxLength={100}
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={24}>
              <Form.Item label='Curso'
                labelCol={{ span: 24 }}
                name='teCurso'
                rules={[
                  {
                    required: true,
                    message: 'O campo Curso é obrigatório.',
                  },
                ]}
              >
                <Input
                  placeholder='Curso'
                  maxLength={100}
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={8} xl={8}>
              <Form.Item label='Carga Horária'
                name='nuCargaHoraria'
                rules={[
                  {
                    required: true,
                    message: "Digite um valor válido",
                  },
                ]}
              >
                <Input
                  onChange={(e) => maskCargaHoraria(e.target.value)}
                  style={{
                    width: "100%",
                  }}
                  maxLength={5}
                  placeholder="Carga Horária"
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>

            <Col xs={8} xl={8}>
              <Form.Item label='Ano Conclusão'
                name='nuAnoConclusao'
                rules={[
                  {
                    required: true,
                    message: "Digite um valor válido",
                  },
                ]}
              >
                <Input
                  onChange={(e) => maskAnoConclusao(e.target.value)}
                  style={{
                    width: "100%",
                  }}
                  maxLength={4}
                  placeholder='Ano'
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>
          </Row>
        </Modal>

      </>

      <Row style={{ display: exibirFormacaoCadastrada }}>
        <Col
          lg={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={formacoes} pagination={false} />
        </Col>
      </Row>

      {/* </Card> */}
    </>
  )
};

export default PessoaFisicaFormacao;